import { Box } from '@chakra-ui/react';
import type * as React from 'react';
import { DemoBookingModal } from './DemoBooking';
import { SiteFooter } from './SiteFooter';
import { SiteNav } from './SiteNav';
import { SmoothAnchors } from './SmoothAnchors';
import { ThemeStyles } from './ThemeToggle';
import { colors, fonts } from '../foundation/tokens';

/** The site chrome: nav, page content, footer. Applied to every
 * page by RootWrapper (except standalone campaign pages). */
export const SiteShell: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Box
    bg={colors.page}
    color={colors.ink}
    fontFamily={fonts.body}
    overflowX="clip"
    minH="100vh"
    display="flex"
    flexDirection="column"
    sx={{ WebkitFontSmoothing: 'antialiased' }}
  >
    <ThemeStyles />
    <SiteNav />
    <Box as="main" flexGrow={1}>
      {children}
    </Box>
    <SiteFooter />
    <DemoBookingModal />
    <SmoothAnchors />
  </Box>
);
